import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {AlertService, PaymentSourceService} from '../_services';
import {FormBuilder} from '@angular/forms';
import {CrudGetComponent} from '../_directives';
import {CreditCardNewFieldsComponent} from "./credit-card-new-fields.component";
import {takeUntil} from "rxjs/operators";
import {PaymentSourceType, StripeAccountType} from "../_models";

@Component({
  moduleId: module.id.toString(),
  templateUrl: './credit-card-new.component.html'
})
export class CreditCardNewComponent extends CrudGetComponent implements OnInit, AfterViewInit {
  @ViewChild(CreditCardNewFieldsComponent, { static: false }) cardFields: CreditCardNewFieldsComponent;

  accountType: StripeAccountType = StripeAccountType.Main;

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected paymentService: PaymentSourceService,
    private formBuilder: FormBuilder,
    protected alertService: AlertService
  ) {
    super(router, location, route, paymentService, alertService);
    this.title = 'Add New Credit Card';
  }

  ngOnInit() {
    super.ngOnInit();
    this.form = this.formBuilder.group({});

    const queryParams = this.route.snapshot.queryParams;
    this.accountType = +queryParams['stripe_account_type'] || StripeAccountType.Main;
  }

  ngAfterViewInit() {
    setTimeout(() => this.form.addControl('billingAddress', this.cardFields.form), 0);
  }

  onSubmit() {
    this.submitted = true;

    if (this.form.valid) {
      this.loading = true;

      this.cardFields.createToken()
        .pipe(takeUntil(this.destroy$))
        .subscribe(result => {
          console.log(result)
          if (result.token) {
            this.paymentService.createFromToken(PaymentSourceType.Card, result.token.id, this.accountType)
              .subscribe(
                data => {
                  this.alertService.success('Added New Credit Card.', true);
                  this.goBack();
                },
                error => {
                  if (error.status === 400) { //bad request
                    if ('token' in error.error) {
                      this.alertService.error(error.error.token);
                    }
                    else {
                      this.handleSubmitError(error);
                    }
                  }
                  else {
                    this.handleError(error);
                  }

                  this.loading = false;
                });
          } else if (result.error) {
            // Error creating the token
            this.alertService.error(result.error.message);
            this.loading = false;
          }
        },error => {
          this.alertService.error(error);
          this.loading = false;
        });
    }
  }
}
